import { ICustomRoute } from 'modules/common/interfaces';

const PublicRoute = ({ componentProps = {}, Component }: ICustomRoute) => {
  return <Component {...componentProps} />;
};

export default PublicRoute;
